// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id });
        // Clear the hash and route to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
        // Force a full reload so AuthProvider picks up cookie
        window.location.reload();
      } catch (e) {
        setErr("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback-screen">
      <div className="text-center">
        <div className="overline text-[var(--lh-mauve)] mb-4">Signing you in</div>
        <div className="font-serif-display text-3xl">One moment…</div>
        {err && <div className="mt-4 text-sm text-red-600" data-testid="auth-callback-error">{err}</div>}
      </div>
    </div>
  );
}
